// removed by extract-text-webpack-plugin
module.exports = {"Wrap":"_25g_K59RItSahnswImtRAw","Nav":"_2gjWyLCKsL7yP9c87VVua3","Tab":"_2pggPXjIjJGFLmam3F5xBe","TabAmount":"_14eszfcUSNH-TJYklDUy4a","Content":"L1NKo9NTKyLk-B1jqQNUr"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Utils/HTabBar/styles.module.css
// module id = 110
// module chunks = 0